(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["totomo-amazon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('totomo-amazon-button')) {
    customElements.define('totomo-amazon-button', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card') || this.closest('.shopify-section');
        this.sequence = 0;
        this.onSelect = async (event) => {
          if (String(event.target?.dataset?.productId || '') !== this.dataset.productId) return;
          const sequence = ++this.sequence;
          const container = this.querySelector('.totomo-amazon-block');
          const link = this.querySelector('a');
          container.hidden = true;
          try {
            const result = await event.promise;
            if (sequence !== this.sequence || !this.isConnected) return;
            const id = result.detail?.resource?.id;
            const urls = JSON.parse(this.querySelector('[data-amazon-variants]').textContent);
            const hasLinks = Object.values(urls).some(Boolean);
            if (!hasLinks) { container.hidden = false; return; }
            const url = urls[String(id)];
            if (url) { link.href = url; container.hidden = false; }
          } catch {}
        };
        import('@shopify/events').then(({ StandardEvents }) => {
          if (!this.isConnected) return;
          this.eventName = StandardEvents.productSelect;
          this.scope?.addEventListener(this.eventName, this.onSelect);
        });
      }
      disconnectedCallback() {
        if (this.eventName) this.scope?.removeEventListener(this.eventName, this.onSelect);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
